"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var initialRoutes = [
    {
        path: 'ssoprelogin',
        loadChildren: function() { return new Promise(function (resolve, reject) {  require.ensure([], function (require) {    resolve(require('@synisys/idm-ui-shell/app/modules/sso-pre-login/sso-pre-login.module')['SSOPreLoginModule']);  }, function(e) {    reject({ loadChunkError: true, details: e });  });}) }
    },
    {
        path: 'registration',
        loadChildren: function() { return new Promise(function (resolve, reject) {  require.ensure([], function (require) {    resolve(require('@synisys/idm-user-data-ui')['RegistrationModule']);  }, function(e) {    reject({ loadChunkError: true, details: e });  });}) }
    },
    {
        path: 'resetpassword',
        loadChildren: function() { return new Promise(function (resolve, reject) {  require.ensure([], function (require) {    resolve(require('@synisys/idm-user-data-ui')['ResetPasswordModule']);  }, function(e) {    reject({ loadChunkError: true, details: e });  });}) }
    },
    {
        path: 'expiredpassword',
        loadChildren: function() { return new Promise(function (resolve, reject) {  require.ensure([], function (require) {    resolve(require('@synisys/idm-user-data-ui')['ExpiredPasswordModule']);  }, function(e) {    reject({ loadChunkError: true, details: e });  });}) }
    },
];
var initialRouteOptions = {
    onSameUrlNavigation: 'reload'
};
var InitialRoutesProvider = /** @class */ (function () {
    function InitialRoutesProvider() {
    }
    InitialRoutesProvider.getRoutes = function () {
        return initialRoutes;
    };
    InitialRoutesProvider.getOptions = function () {
        return initialRouteOptions;
    };
    return InitialRoutesProvider;
}());
exports.InitialRoutesProvider = InitialRoutesProvider;
//# sourceMappingURL=initial-routes-provider.js.map